/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-01 16:28:51
 */

export default [
  {
    path: '/drawCourseware',
    name: '抽取课件',
    hidden: false,
    component: () => import('@/views/Application.vue'),
    meta: {
      title: '抽取演讲节段',
      icon: 'fa fa-star iconTitle',
      role: ['scene_sequence'],
      level: 1
    },
    children: [
      {
        path: '/drawCourseware',
        name: '抽取课件',
        hidden: false,
        component: () =>
          import('@/views/extract-courseware/DrawCourseware.vue'),
        meta: {
          title: '抽取演讲节段',
          icon: 'fa fa-star iconTitle',
          role: ['scene_sequence'],
          level: 1
        }
      }
    ]
  },
  {
    path: '/drawSubjectScreen',
    name: '抽取演讲节段',
    hidden: true,
    component: resolve =>
      require([
        '@/views/extract-courseware/NewDrawSubjectOfScreen.vue'
      ], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/router/extract-courseware/index.js